import { render, staticRenderFns } from "./EmojiIcon.vue?vue&type=template&id=a21573fa&scoped=true"
import script from "./EmojiIcon.vue?vue&type=script&lang=js"
export * from "./EmojiIcon.vue?vue&type=script&lang=js"
import style0 from "./EmojiIcon.vue?vue&type=style&index=0&id=a21573fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21573fa",
  null
  
)

export default component.exports